<h1 mat-dialog-title class="p-2 text-center">{{model.QuestionTitle}}</h1>
<div class="row g-0">
  <mat-form-field *ngIf="model.WithReason" class="col-12 p-3">
    <mat-label>message</mat-label>
    <textarea matInput placeholder="message" [(ngModel)]="model.Reason" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" [formControl]="ValidReasonMaxLength"></textarea>
    <mat-hint align="end">{{model.Reason?.length || 0}}/{{REASON_MAX_SIZE}}</mat-hint>
    <mat-error *ngIf="ValidReasonMaxLength.hasError('maxlength')">
      Texte trop long
    </mat-error>
  </mat-form-field>
  <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
    Non
  </button>
  <button appPreventDoubleClick [disabled]="ValidReasonMaxLength.hasError('maxlength')" class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()">
    Oui
  </button>
</div>